import { t } from 'i18next'
import { Progress } from '@radix-ui/themes'

interface AirdropCardProps {
  title: string
  subtitle: string
  completedTasks: string
  totalTasks: string
  estReward: string
  buttonAction: string
  icon?: string
  onActionClick: () => void
}

const AirdropCard = ({
  title,
  subtitle,
  completedTasks,
  totalTasks,
  estReward,
  buttonAction,
  icon,
  onActionClick
}: AirdropCardProps) => {
  return (
    <div className="flex flex-col md:grid md:grid-cols-[1.5fr_2fr_1fr_1fr] gap-6 items-start md:items-center hover:scale-101 transition-all ease-in-out duration-300 p-6 border shadow-xs dark:border-2 border-border-base dark:border-[#FFFFFF0D] rounded-2xl">
      {/* Name and icon*/}
      <div className="flex gap-4 items-center w-full md:w-auto">
        <div className="p-3 h-10 w-10 rounded-lg primary-gradient">{icon}</div>
        <div className="flex flex-col">
          <h3 className="text-text-main font-bold text-lg">{title}</h3>
          <p className="text-text-secondary text-sm">{subtitle}</p>
        </div>
      </div>
      {/* Progress */}
      <div className="flex flex-col gap-3 justify-center w-full md:w-auto">
        <div className="flex text-xs justify-between">
          <p className="text-text-secondary">{t('airdrops.completedTasks')}</p>
          <p className="text-accent font-bold">
            {completedTasks}/{totalTasks}
          </p>
        </div>
        <div className="h-1.5">
          <Progress
            variant="soft"
            color="amber"
            value={parseInt(completedTasks) * (100 / parseInt(totalTasks))}
          />
        </div>
      </div>

      {/* Reward and button */}

      <div className="flex flex-col items-start md:items-end w-full md:w-auto">
        <p className="text-text-secondary uppercase text-xs">
          {t('airdrops.estReward')}
        </p>
        <h3 className="text-text-main font-bold">{estReward}</h3>
      </div>

      <button
        onClick={onActionClick}
        className="w-full md:w-auto md:justify-self-end primary-gradient-text text-lg py-1 px-8 font-bold"
      >
        {buttonAction == 'claim' ? t('airdrops.claim') : t('airdrops.join')}
      </button>
    </div>
  )
}

export default AirdropCard
